import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { title: 'Ukraine Energy Map' },
  },
  {
    path: '/methodology',
    name: 'methodology',
    component: () => import('@/views/Methodology.vue'),
    meta: { title: 'Methodology — Ukraine Energy Map' },
  },
  {
    path: '/downloads',
    name: 'downloads',
    component: () => import('@/views/Downloads.vue'),
    meta: { title: 'Downloads — Ukraine Energy Map' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFound.vue'),
    meta: { title: 'Not found — Ukraine Energy Map' },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, saved) {
    if (saved) return saved
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  },
})

router.afterEach((to) => {
  const title = typeof to.meta.title === 'string' ? to.meta.title : 'Ukraine Energy Map'
  document.title = title
})
